import React from "react";

import { HelpIcon as Help, Typography } from "@packages/ds";
import { FormattedMessage, useIntl } from "react-intl";

import { AddButton } from "ds/Button";
import useDecodedParams from "Hooks/useDecodedParams";

import {
  Flex,
  Info,
  MoreInfo,
  Section,
  LearnMoreLink
} from "./SectionHeader.styles";

const Header = () => {
  const intl = useIntl();
  const { organizationId, projectId } = useDecodedParams<{
    organizationId: string;
    projectId: string;
  }>();

  const ADD_INTEGRATION_ROUTE = `/${organizationId}/${projectId}/-/settings/integrations/setup`;

  return (
    <Section>
      <Flex>
        <Typography.Title tag="h3">
          {intl.formatMessage({
            id: "integrations.title",
            defaultMessage: "Integrations"
          })}
        </Typography.Title>
        <AddButton to={ADD_INTEGRATION_ROUTE} analyticId="integrations.add">
          {intl.formatMessage({
            id: "integrations.add",
            defaultMessage: "Add integration"
          })}
        </AddButton>
      </Flex>
      <Info>{intl.formatMessage({ id: "integration.info.content" })}</Info>

      <MoreInfo>
        <Help />
        <FormattedMessage
          id="integration.info.link"
          values={{
            a: chunks => (
              <LearnMoreLink
                analyticId="links.documentation.integrations"
                href={intl.formatMessage({
                  id: "links.documentation.integrations"
                })}
              >
                {chunks}
              </LearnMoreLink>
            )
          }}
        />
      </MoreInfo>
    </Section>
  );
};

export default Header;
